var render = function render(_c,_vm){return _c('span',{staticClass:"speaker",class:{'speaker-no-active': !_vm.props?.speaker?.is_active}},[_c('span',{staticClass:"text-id_eps mr-2"},[_vm._v(_vm._s(_vm.props?.speaker?.id_speaker_eps || _vm.props?.value))]),_c('span',{staticClass:"text-name"},[_vm._v(_vm._s(_vm.props?.speaker['name_' + _vm.props.language]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }